import type { ChartMode } from '../charts/cashflow-utils'

export function ChartModeToggle({
  mode,
  onChange,
}: {
  mode: ChartMode
  onChange: (mode: ChartMode) => void
}) {
  return (
    <div className="inline-flex rounded-md border border-primary-200 text-xs dark:border-primary-700">
      <button
        type="button"
        onClick={() => onChange('cumulative')}
        className={`rounded-l-md px-2 py-0.5 font-medium transition-colors ${
          mode === 'cumulative'
            ? 'bg-accent-100 text-accent-700 dark:bg-accent-900 dark:text-accent-300'
            : 'text-primary-500 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-200'
        }`}
      >
        Cumulative
      </button>
      <button
        type="button"
        onClick={() => onChange('monthly')}
        className={`rounded-r-md px-2 py-0.5 font-medium transition-colors ${
          mode === 'monthly'
            ? 'bg-accent-100 text-accent-700 dark:bg-accent-900 dark:text-accent-300'
            : 'text-primary-500 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-200'
        }`}
      >
        Monthly
      </button>
    </div>
  )
}
